(function (angular) {
	'use strict';

	var serviceLevelCardObject = {
		templateUrl: [
			'STATIC_BASE_PATH',
			templateUrlFunction
		],
		bindings: {
			selectCallback: '&'
		},
		controller: [
			'$timeout',
			ServiceLevelCardFunction
		],
		controllerAs: 'serviceLevelCards'
	};

	angular
		.module('serviceLevelCardModule')
		.component('serviceLevelCards', serviceLevelCardObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/service-level/service-level-card.html';
	}

	function ServiceLevelCardFunction(
		$timeout
	) {
		var serviceLevelCards = this;

		serviceLevelCards.handleSelectionAndRedirect = function(card) {
			serviceLevelCards.selectCallback({serviceLevel: card.serviceLevel});
		};

		serviceLevelCards.shouldFadeCard = function(serviceLevel) {
			switch(serviceLevel) {
				case 'STARTER':
					return serviceLevelCards.fadeInStarterCard;
				case 'CORE':
					return serviceLevelCards.fadeInCoreCard;
				case 'ADVANCED':
					return serviceLevelCards.fadeInAdvancedCard;
				default:
					return false;
			}
		};

		serviceLevelCards.$onInit = function () {
			serviceLevelCards.cards = [{
				description: 'With a $500 minimum initial investment, getting started with real estate investing has never been&nbsp;easier.',
				displayName: 'Starter',
				initialInvestment: '$500 &ndash; $1,000',
				projectCount: '5 &ndash; 10',
				serviceLevel: 'STARTER'
			}, {
				description: 'A solid foundation. Diversify across dozens of projects and tailor your portfolio to your investment&nbsp;objectives.',
				displayName: 'Core',
				initialInvestment: '$1,000 &ndash; $10,000',
				projectCount: '40+',
				serviceLevel: 'CORE'
			}, {
				description: 'Everything you get with Core, plus diversify into more sophisticated strategies with higher potential&nbsp;returns.',
				displayName: 'Advanced',
				initialInvestment: '$10,000+',
				projectCount: '80+',
				serviceLevel: 'ADVANCED'
			}];

			$timeout(function() {
				serviceLevelCards.animateArrowPath = true;
			}, 100);

			$timeout(function() {
				serviceLevelCards.fadeInStarterCard = true;
			}, 300);

			$timeout(function() {
				serviceLevelCards.fadeInCoreCard = true;
			}, 500);

			$timeout(function() {
				serviceLevelCards.fadeInAdvancedCard = true;
			}, 700);

			$timeout(function() {
				serviceLevelCards.animateArrowHead = true;
			}, 1100);
		};
	}
})(window.angular);
